import React, { useEffect, useState } from "react";
import partnerService from "../../../services/partners";
import { instanceToken } from "../../../utils/constant";
import { useNavigate, Link } from "react-router-dom";

import {
  Breadcrumbs,
  Button,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Table,
  TablePagination,
  Avatar,
} from "@mui/material";
import { TableRowsRounded } from "@mui/icons-material";
import axios from "axios";

export default function Partners() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [partners, setPartners] = useState(null);

  useEffect(() => {
    fetchPartners(rowsPerPage, offset);
  }, [offset, rowsPerPage]);

  const fetchPartners = async (limit, offset) => {
    try {
      const res = await partnerService.getPartners(
        instanceToken.token,
        limit,
        offset
      );

      parse(res.data);
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };

  const parse = (data) => {
    console.log("data are ", data);
    setPartners(data.partners);
    setCount(data.count);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  console.log(partners);
  if (!partners) {
    return <em>Loading</em>;
  }

  //Change data from String to object with JSON
  // if (typeof res.data.address !== "object") {
  //   try {
  //     let address = JSON.parse(res.data.address);
  //     user = { ...result.data.users_by_pk, address };
  //   } catch (e) {
  //     user = { ...result.data.users_by_pk };
  //   }
  // } else user = { ...result.data.users_by_pk, address: "-" };

  return (
    <>
      <div role="presentation" style={{ marginBlockEnd: "10px" }}>
        <Breadcrumbs aria-label="breadcrumb">
          <span>Partners</span>
        </Breadcrumbs>
      </div>

      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button
          variant="contained"
          sx={{ my: 3 }}
          onClick={() => navigate("/createPartner")}
        >
          Create
        </Button>
      </div>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple-table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              {/* <TableCell>Image</TableCell> */}
              <TableCell>Name Eng</TableCell>
              <TableCell>Name MM</TableCell>
              <TableCell>Address Eng</TableCell>
              <TableCell>Address MM</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Phone Note</TableCell>
              <TableCell>Link</TableCell>
              <TableCell>Promotion</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {partners.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.id}
                </TableCell>
                {/* <TableCell component="th" scope="row">
                  <Avatar
                    alt="partner image"
                    src={`data:image/png;base64,${row.image_data}`}
                    width="56px"
                    height="56px"
                  />
                </TableCell> */}
                <TableCell>{row.name_en}</TableCell>
                <TableCell>{row.name_mm}</TableCell>
                <TableCell>{row.address_en.substring(0, 30)}</TableCell>
                <TableCell>{row.address_mm.substring(0, 30)}</TableCell>
                <TableCell>{row.phone}</TableCell>
                <TableCell>{row.category}</TableCell>
                <TableCell>{row.phone_note?.substring(0, 30)}</TableCell>
                <TableCell>
                  <a href={row.link} target="_parent">
                    {row.link.substring(0, 20)}
                  </a>
                </TableCell>
                <TableCell>{row.promotion}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>
                  <Button
                    size="small"
                    component={Link}
                    color="secondary"
                    to={`/privilege/${row.id}`}
                  >
                    Details
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </>
  );
}
